export default {"src":"/_next/static/media/download-app-apple.c2ae3d95.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};